import * as React from "react";
import { withRouter } from "react-router-dom";
import { SignInForm } from "./SignInForm";
import { Grid, Image , Segment, Responsive } from 'semantic-ui-react';
import logo from '../../images/logo.png';

const SignInComponent = ({ history }: { [key: string]: any }) => (
      <Grid
        textAlign="center"
        style={{ height: '105vh', paddingTop:"50px"}}
        verticalAlign="middle"
      >
        <Grid.Column
          style={{
            maxWidth: '90%',
            width: '550px',
          }}
        >
          <Responsive as={Segment}>
            <Image src={logo} style={{ padding: '48px' , verticalAlign:"center" , marginLeft: "auto",
              marginRight: "auto",
              width: "50%" }} />
          </Responsive>
           <SignInForm history={history} />
        </Grid.Column>
      </Grid>
);

export const SignIn = withRouter(SignInComponent);


// WEBPACK FOOTER //
// ./src/pages/SignIn/index.tsx